module.exports = __webpack_public_path__ + "img/admin_avatar.8bf270fa.png";